module.exports = __webpack_public_path__ + "static/media/wyoming-seal-gray-400x.84c30172.png";